import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Divider from '@material-ui/core/Divider';

import Image from './Image';

const styles = theme => ({
  spacing: {
    padding: '20px 0',
  },
  description: {
    fontSize: 19,
    color: theme.palette.grey.main,
  },
  mission: {
    color: theme.palette.primary.main,
    fontFamily: 'Signika, Roboto, Arial',
    fontWeight: 'bold',
    fontSize: 40
  },
  first: {
    order: 1,
    borderRightColor: theme.palette.primary.main,
    [theme.breakpoints.down('sm')]: {
      order: 2
    }
  },
  second: {
    order: 2,
    [theme.breakpoints.down('sm')]: {
      order: 1
    }
  },
  section: {
    padding: 20
  }
});


class PageSection extends Component {

  render() {
    const { classes, section, circular, plain, fullWidth, divider } = this.props;
    let backgroundColor = section.id % 2 !== 0 ? '#ffffff' : '#edf0f4';

    if (plain) {
      backgroundColor = 'none';
    }

    const width = fullWidth ? 12 : 8;

    return (
      <div key={section.id} style={{background: backgroundColor}} className={classes.section}>
        <Grid container
          spacing={2}
          direction="row"
          alignItems="center"
          justifyContent="center"
          className={classes.spacing}
        >
          <Grid item xs={12} sm={width}>

            <Grid container
              spacing={2}
              direction="row"
              alignItems="center"
              justifyContent="space-between"
            >
              <Grid item xs={12} sm={6} className={classes.first}>
                <Typography className={classes.mission} variant="h5">
                  {section.title}
                </Typography>
                <Typography variant="subtitle1" className={classes.description}>
                  {section.description}
                </Typography>
              </Grid>

              <Grid item xs={12} sm={6} className={classes.second}>
                { circular &&
                  <Image src={section.image} alt={section.title} />
                }
                { !circular &&
                  <img src={section.image} alt={section.title} width="100%" />
                }
              </Grid>
            </Grid>

          </Grid>
        </Grid>
        { !!divider && <Divider /> }
      </div>
    )
  }
}

PageSection.propTypes = {
  classes: PropTypes.object.isRequired
}

export default withStyles(styles)(PageSection);



